import { get as _get, size, uniqueId } from "lodash";
import { getPlatformColor } from "@linkfluence/models/platform";

export function getAccount(obj, platform) {
  const get = (key, defaultValue) => _get(obj, key, defaultValue);

  let websites = get("socialAccount.o-website", []);

  const website = get("socialAccount.website", "");

  if (!size(websites) && website !== "") {
    websites = [website];
  }

  const id = "" + get("idStr", get("id", uniqueId()));

  const name = get("name", "");
  const screenName = get("screenName", "") || "";
  const color = getPlatformColor(platform) || "#FFFFFF";
  const picture = get("profileImg", "");
  return {
    relationType: get("relationType", "me"),
    platform: platform,
    id: id,
    color: color,
    uid: get("uid", id),
    picture: picture ? "" + picture : "",
    smallPicture: picture ? "" + picture : "",
    bigPicture: picture ? "" + picture : "",
    label: name === null ? "" : "" + name,
    kpisInfluencers: {},
    screenName: "" + screenName,
    url: "" + get("permalink", ""),
    tag: get("tags", []),
    comment: get("comment", ""),
    email: get("email", []),
    website: websites,
    country: get(["geo", "country"], null),
    query: "user." + platform + ".id:" + id,
    occupation: get("occupation", []),
    verified: get("verified", false),
    trashed: get("trashed", false),
    credentialId: get("credentialId", false),
    credentialIds: get("credentialIds", []),
    error: get("error", null),
    anonymous: get("anonymous", false),
  };
}
